<template>
  <div class="full-container" ref="scroll">
    <!-- List -->
    <div class="list-container" ref="listContainer">
      <CommentSingle 
        v-for="comment in comments"
        :key="comment.id"
        :post="post" 
        :model="model"
        :data="comment" 
        @delete="deleteCommentHandler"
        @reply="replyHandler"
        @changeHeight="raiseChangeListHeight"
      />
    </div>

    <!-- Error -->
    <div v-if="errorFetching">
      <p>
        {{ $t("error") }}
      </p>
      <button style="width: 100%;" type="button" @click="loadComments">
        {{ $t("retry") }}
      </button>
    </div>
    <!-- Loading -->
    <div class="spinner" v-else-if="waitFetch">
      <Spinner />
    </div>
  </div>
</template>

<script>
import resources from "../../resources";
import Spinner from "../Spinner.vue";
import CommentSingle from "./Single.vue";

export default {
  components: { CommentSingle, Spinner },
  props: {
    post: {
      type: Object,
      required: true,
    },
    model: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      comments: [],
      errorFetching: false,
      waitFetch: false,
      nextPage: null,
      excludedComments: [],
    };
  },
  methods: {
    deleteCommentHandler(commentId) {
      const filterComment = (commentList) => {
        return commentList.filter((comment) => comment.id !== commentId);
      };
      
      this.excludedComments = filterComment(this.excludedComments);
      this.comments = filterComment(this.comments);
    },
    appendComment(comment) {
      this.excludedComments.push(comment.id);
      this.comments.unshift(comment);

      this.raiseChangeListHeight();
    },
    loadComments() {
      this.waitFetch = true;
      this.errorFetching = false;

      let fetchRequest = null;

      if (this.nextPage) {
        fetchRequest = resources.comments.getCommentsByPaginatorLink(this.nextPage);
      } else {
        fetchRequest = resources.comments.getComments(this.post.post_id);
      }

      this.nextPage = null;

      fetchRequest
        .then((response) => {
          let data = response.data.data;
          const meta = response.data.meta;

          if (this.excludedComments.length) {
            data = data.filter(
              (comment) => !this.excludedComments.includes(comment.id)
            );
          }

          this.comments = this.comments.concat(data);
          this.raiseChangeListHeight();

          if (!meta || !meta.pagination) return;
          const pagination = meta.pagination;

          if (pagination.current_page < meta.pagination.total_pages && meta.pagination.links) {
            this.nextPage = meta.pagination.links.next;
          }
        })
        .catch((error) => {
          console.log(error);
          this.errorFetching = true;
        })
        .finally(() => {
          this.waitFetch = false;
        });
    },
    replyHandler(data) {
      this.$emit("reply", data);
    },
    raiseChangeListHeight() {
      this.$nextTick(() => {
        this.$emit("changeHeight", this.$refs.listContainer.clientHeight);
      });
    },
    endOfScrollReached:_.throttle(function() {
      if (this.nextPage) this.loadComments();
    }, 500),
  },
  mounted() {
    this.loadComments();
  },
  name: "CommentList",
};
</script>

<style scoped lang="scss">
.full-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: fit-content;
  margin: 0;
  padding: 0;
}

.list-container {
  display: flex;
  width: 100%;
  height: fit-content;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
  padding-block: 0;
  padding-inline: 1em;
}

.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
